import * as ActionErrors from "./Action";

export default {
  ...ActionErrors,
};
